import { useEffect, useState } from 'react';

export const useThemeController = (getThemeByName: any) => {
  const [themeName, _setThemeName] = useState('light');

  useEffect(() => {
    _setThemeName(localStorage.getItem('theme') || 'light');
  }, []);

  const theme = getThemeByName(themeName);

  const onChangeTheme = (name: string) => {
    localStorage.setItem('theme', name);
    _setThemeName(name);
  };

  const contextValue = {
    currentTheme: themeName,
    setTheme: onChangeTheme,
  };

  return { theme, contextValue };
};
